// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("assets/images/dark_background.webp", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.topper {
	display: flex;
	flex-direction: column;
	margin-top: 5rem;
	padding: 8rem 0.5rem;

	width: 100%;
	background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) top center/contain
		no-repeat;
	background-size: 100% 100%;
	flex-basis: 20rem;
	justify-content: flex-start;
	align-content: center;
	align-items: center;
	justify-items: center;
	min-height: 300px;
	clip-path: polygon(0% 0%, 100% 0%, 100% 80%, 50% 90%, 0% 80%);
}

.topper-content {
	margin-top: 1rem;
	display: flex;
	flex-direction: column;
	color: white;
	background-color: transparent;
	text-align: center;
	font-size: 3.4rem;
	line-height: 2.5rem;
	z-index: 9;
}
.owner {
	z-index: 9;
}
.owner p {
	font-size: 1.3rem;
	line-height: 2.3rem;
	color: white;
}
.owner-link {
	z-index: 9;
}
.owner-link a {
	font-size: 1.3rem;
	line-height: 3.5vw;
	color: var(--secondary-color2);
	text-decoration: none;
}
.reference {
	z-index: 9;
}

.reference p {
	font-size: 1.2rem;
	line-height: 1rem;
	color: white;
}

.topper-content p {
	font-size: 1.4rem;
	line-height: 2.4rem;
}
.topper-title {
	z-index: 9;
}
.topper-title h1 {
	color: white;
	font-size: 1.8rem;
	margin: 0rem;
}
.topper-content h1 {
	font-size: 1.8rem;
	margin-top: 2rem;
	margin-right: 0;
	padding-right: 0;
}

.bottom-container {
	display: flex;
	flex-direction: column;
	padding-top: 0rem;
	margin: 0rem;
	width: 100%;
}

@media (min-width: 500px) {
	.topper {
		flex-basis: 30vw;
		flex-grow: 1;
		justify-content: flex-start;
		justify-items: center;
		min-height: 300px;
		width: 100%;
		clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 80%);
		margin-top: 0px;
	}
	.topper-content {
		width: 80%;
	}
	.topper-content p {
		font-size: 2vw;
		line-height: 3vw;
		margin-right: 2vw;
		margin-top: 0px;
	}
	.topper-title h1 {
		font-size: 2.5vw;
	}
	.topper-content h3 {
		/*    font-size: 1.4rem;*/
		margin-right: 2rem;
	}

	.owner p {
		font-size: 1.8vw;
		line-height: 3vw;
		color: white;
	}

	.owner-link a {
		font-size: 1.8vw;
		line-height: 3vw;
		color: var(--secondary-color2);
		text-decoration: none;
	}
	.reference p {
		font-size: 1.4vw;
		line-height: 1vw;
		color: white;
	}
}

@media (min-width: 1000px) {
	.topper {
		flex-basis: 40vh;
		clip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 80%);
		display: flex;
		width: 100%;
		justify-content: center;
		align-content: center;
	}
	.topper-content {
		width: 100%;
		line-height: 2.5rem;
		justify-content: center;
		align-items: center;
		align-content: center;
	}

	.topper-content p {
		text-align: center;
		margin-right: 0px;
		font-size: 1.8rem;
		line-height: 2.8rem;
		margin-right: 2vw;
		margin-top: 0px;
	}
	.topper-content span {
		margin-right: 0px;
		font-size: 1.6rem;
		line-height: 3rem;
	}
	.topper-title {
		display: flex;
		justify-content: center;
		width: 100%;
		color: white;
	}

	.topper-title h1 {
		margin: unset;
		font-size: 2.5rem;
		text-align: right;
	}
	.owner p {
		font-size: 1.6rem;
		line-height: 2.4rem;
		color: white;
	}

	.owner-link a {
		font-size: 1.6rem;
		line-height: 3rem;
		color: var(--secondary-color2);
		text-decoration: none;
	}
	.reference p {
		font-size: 1.4rem;
		line-height: 1rem;
		color: white;
	}
}
`, "",{"version":3,"sources":["webpack://./src/pages/GenericPage/Topper/topper.css"],"names":[],"mappings":"AAAA;CACC,aAAa;CACb,sBAAsB;CACtB,gBAAgB;CAChB,oBAAoB;;CAEpB,WAAW;CACX;WACU;CACV,0BAA0B;CAC1B,iBAAiB;CACjB,2BAA2B;CAC3B,qBAAqB;CACrB,mBAAmB;CACnB,qBAAqB;CACrB,iBAAiB;CACjB,6DAA6D;AAC9D;;AAEA;CACC,gBAAgB;CAChB,aAAa;CACb,sBAAsB;CACtB,YAAY;CACZ,6BAA6B;CAC7B,kBAAkB;CAClB,iBAAiB;CACjB,mBAAmB;CACnB,UAAU;AACX;AACA;CACC,UAAU;AACX;AACA;CACC,iBAAiB;CACjB,mBAAmB;CACnB,YAAY;AACb;AACA;CACC,UAAU;AACX;AACA;CACC,iBAAiB;CACjB,kBAAkB;CAClB,8BAA8B;CAC9B,qBAAqB;AACtB;AACA;CACC,UAAU;AACX;;AAEA;CACC,iBAAiB;CACjB,iBAAiB;CACjB,YAAY;AACb;;AAEA;CACC,iBAAiB;CACjB,mBAAmB;AACpB;AACA;CACC,UAAU;AACX;AACA;CACC,YAAY;CACZ,iBAAiB;CACjB,YAAY;AACb;AACA;CACC,iBAAiB;CACjB,gBAAgB;CAChB,eAAe;CACf,gBAAgB;AACjB;;AAEA;CACC,aAAa;CACb,sBAAsB;CACtB,iBAAiB;CACjB,YAAY;CACZ,WAAW;AACZ;;AAEA;CACC;EACC,gBAAgB;EAChB,YAAY;EACZ,2BAA2B;EAC3B,qBAAqB;EACrB,iBAAiB;EACjB,WAAW;EACX,qDAAqD;EACrD,eAAe;CAChB;CACA;EACC,UAAU;CACX;CACA;EACC,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;CAChB;CACA;EACC,gBAAgB;CACjB;CACA;EACC,yBAAyB;EACzB,kBAAkB;CACnB;;CAEA;EACC,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;CACb;;CAEA;EACC,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,qBAAqB;CACtB;CACA;EACC,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;CACb;AACD;;AAEA;CACC;EACC,gBAAgB;EAChB,qDAAqD;EACrD,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,qBAAqB;CACtB;CACA;EACC,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,qBAAqB;CACtB;;CAEA;EACC,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;CAChB;CACA;EACC,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;CAClB;CACA;EACC,aAAa;EACb,uBAAuB;EACvB,WAAW;EACX,YAAY;CACb;;CAEA;EACC,aAAa;EACb,iBAAiB;EACjB,iBAAiB;CAClB;CACA;EACC,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;CACb;;CAEA;EACC,iBAAiB;EACjB,iBAAiB;EACjB,8BAA8B;EAC9B,qBAAqB;CACtB;CACA;EACC,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;CACb;AACD","sourcesContent":[".topper {\n\tdisplay: flex;\n\tflex-direction: column;\n\tmargin-top: 5rem;\n\tpadding: 8rem 0.5rem;\n\n\twidth: 100%;\n\tbackground: url(\"assets/images/dark_background.webp\") top center/contain\n\t\tno-repeat;\n\tbackground-size: 100% 100%;\n\tflex-basis: 20rem;\n\tjustify-content: flex-start;\n\talign-content: center;\n\talign-items: center;\n\tjustify-items: center;\n\tmin-height: 300px;\n\tclip-path: polygon(0% 0%, 100% 0%, 100% 80%, 50% 90%, 0% 80%);\n}\n\n.topper-content {\n\tmargin-top: 1rem;\n\tdisplay: flex;\n\tflex-direction: column;\n\tcolor: white;\n\tbackground-color: transparent;\n\ttext-align: center;\n\tfont-size: 3.4rem;\n\tline-height: 2.5rem;\n\tz-index: 9;\n}\n.owner {\n\tz-index: 9;\n}\n.owner p {\n\tfont-size: 1.3rem;\n\tline-height: 2.3rem;\n\tcolor: white;\n}\n.owner-link {\n\tz-index: 9;\n}\n.owner-link a {\n\tfont-size: 1.3rem;\n\tline-height: 3.5vw;\n\tcolor: var(--secondary-color2);\n\ttext-decoration: none;\n}\n.reference {\n\tz-index: 9;\n}\n\n.reference p {\n\tfont-size: 1.2rem;\n\tline-height: 1rem;\n\tcolor: white;\n}\n\n.topper-content p {\n\tfont-size: 1.4rem;\n\tline-height: 2.4rem;\n}\n.topper-title {\n\tz-index: 9;\n}\n.topper-title h1 {\n\tcolor: white;\n\tfont-size: 1.8rem;\n\tmargin: 0rem;\n}\n.topper-content h1 {\n\tfont-size: 1.8rem;\n\tmargin-top: 2rem;\n\tmargin-right: 0;\n\tpadding-right: 0;\n}\n\n.bottom-container {\n\tdisplay: flex;\n\tflex-direction: column;\n\tpadding-top: 0rem;\n\tmargin: 0rem;\n\twidth: 100%;\n}\n\n@media (min-width: 500px) {\n\t.topper {\n\t\tflex-basis: 30vw;\n\t\tflex-grow: 1;\n\t\tjustify-content: flex-start;\n\t\tjustify-items: center;\n\t\tmin-height: 300px;\n\t\twidth: 100%;\n\t\tclip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 80%);\n\t\tmargin-top: 0px;\n\t}\n\t.topper-content {\n\t\twidth: 80%;\n\t}\n\t.topper-content p {\n\t\tfont-size: 2vw;\n\t\tline-height: 3vw;\n\t\tmargin-right: 2vw;\n\t\tmargin-top: 0px;\n\t}\n\t.topper-title h1 {\n\t\tfont-size: 2.5vw;\n\t}\n\t.topper-content h3 {\n\t\t/*    font-size: 1.4rem;*/\n\t\tmargin-right: 2rem;\n\t}\n\n\t.owner p {\n\t\tfont-size: 1.8vw;\n\t\tline-height: 3vw;\n\t\tcolor: white;\n\t}\n\n\t.owner-link a {\n\t\tfont-size: 1.8vw;\n\t\tline-height: 3vw;\n\t\tcolor: var(--secondary-color2);\n\t\ttext-decoration: none;\n\t}\n\t.reference p {\n\t\tfont-size: 1.4vw;\n\t\tline-height: 1vw;\n\t\tcolor: white;\n\t}\n}\n\n@media (min-width: 1000px) {\n\t.topper {\n\t\tflex-basis: 40vh;\n\t\tclip-path: polygon(0% 0%, 100% 0%, 100% 100%, 0% 80%);\n\t\tdisplay: flex;\n\t\twidth: 100%;\n\t\tjustify-content: center;\n\t\talign-content: center;\n\t}\n\t.topper-content {\n\t\twidth: 100%;\n\t\tline-height: 2.5rem;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\talign-content: center;\n\t}\n\n\t.topper-content p {\n\t\ttext-align: center;\n\t\tmargin-right: 0px;\n\t\tfont-size: 1.8rem;\n\t\tline-height: 2.8rem;\n\t\tmargin-right: 2vw;\n\t\tmargin-top: 0px;\n\t}\n\t.topper-content span {\n\t\tmargin-right: 0px;\n\t\tfont-size: 1.6rem;\n\t\tline-height: 3rem;\n\t}\n\t.topper-title {\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\twidth: 100%;\n\t\tcolor: white;\n\t}\n\n\t.topper-title h1 {\n\t\tmargin: unset;\n\t\tfont-size: 2.5rem;\n\t\ttext-align: right;\n\t}\n\t.owner p {\n\t\tfont-size: 1.6rem;\n\t\tline-height: 2.4rem;\n\t\tcolor: white;\n\t}\n\n\t.owner-link a {\n\t\tfont-size: 1.6rem;\n\t\tline-height: 3rem;\n\t\tcolor: var(--secondary-color2);\n\t\ttext-decoration: none;\n\t}\n\t.reference p {\n\t\tfont-size: 1.4rem;\n\t\tline-height: 1rem;\n\t\tcolor: white;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
